'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dScheduled$002dMeal$002dSearch from "./mealorama.-Scheduled-Meal-Search.js";
var $p;
/** @constructor */
function $c_Lmealorama_ScheduledMealSearch$() {
  this.am4 = null;
  this.am5 = false;
}
export { $c_Lmealorama_ScheduledMealSearch$ as $c_Lmealorama_ScheduledMealSearch$ };
$p = $c_Lmealorama_ScheduledMealSearch$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_ScheduledMealSearch$;
/** @constructor */
function $h_Lmealorama_ScheduledMealSearch$() {
}
export { $h_Lmealorama_ScheduledMealSearch$ as $h_Lmealorama_ScheduledMealSearch$ };
$h_Lmealorama_ScheduledMealSearch$.prototype = $p;
$p.aQy = (function() {
  if ((!this.am5)) {
    this.am4 = new $j_mealorama$002e$002dScheduled$002dMeal$002dSearch.$c_Lmealorama_ScheduledMealSearch($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$(), false, false, 0, 10, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
    this.am5 = true;
  }
  return this.am4;
});
$p.aSv = (function(x$0) {
  return new $j_mealorama$002e$002dScheduled$002dMeal$002dSearch.$c_Lmealorama_ScheduledMealSearch(x$0.g(0), x$0.g(1), x$0.g(2), (!(!x$0.g(3))), (!(!x$0.g(4))), (x$0.g(5) | 0), (x$0.g(6) | 0), x$0.g(7));
});
var $d_Lmealorama_ScheduledMealSearch$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_ScheduledMealSearch$, "mealorama.ScheduledMealSearch$", ({
  GX: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_ScheduledMealSearch$ as $d_Lmealorama_ScheduledMealSearch$ };
var $n_Lmealorama_ScheduledMealSearch$;
function $m_Lmealorama_ScheduledMealSearch$() {
  if ((!$n_Lmealorama_ScheduledMealSearch$)) {
    $n_Lmealorama_ScheduledMealSearch$ = new $c_Lmealorama_ScheduledMealSearch$();
  }
  return $n_Lmealorama_ScheduledMealSearch$;
}
export { $m_Lmealorama_ScheduledMealSearch$ as $m_Lmealorama_ScheduledMealSearch$ };
//# sourceMappingURL=mealorama.-Scheduled-Meal-Search$.js.map
